import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const OnboardingApproval = lazy(() => import("../pages/onboarding-approval"));
const OnboardingApprovalDetails = lazy(() =>
  import("../pages/onboarding-approval-editable")
);
const CampaignApproval = lazy(() => import("../pages/campaign-approval"));
const CampaignApprovalDetails = lazy(() =>
  import("../pages/campaign-approval-details")
);
const OnboardingTask = lazy(() => import("../pages/onboarding-task"));
const OnboardingTaskDetails = lazy(() =>
  import("../pages/onboarding-task-details")
);
const AbTestApprovalDetails = lazy(() =>
  import("../pages/ab-test-approval-details")
);
const AbTestFinalApprovalDetails = lazy(() =>
  import("../pages/ab-test-final-approval-details")
);
const ActionList = lazy(() => import("../pages/all-action-list"));
const EngagementTasks = lazy(() => import("../pages/engagement-tasks"));
const EngagementTaskDetails = lazy(() =>
  import("../pages/engagement-task-details")
);
const ReplyTaskDetails = lazy(() => import("../pages/reply-task-details"));
const ActionDetails = lazy(() => import("../pages/action-details"));
const MyActionList = lazy(() => import("../pages/my-action-list"));
const OnboardingTaskView = lazy(() => import("../pages/onboarding-task-view"));

export const ActionRouter = [
  {
    path: "action",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "onboarding-task",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingTask />
          </Suspense>
        ),
      },
      {
        path: "engagement-task",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EngagementTasks />
          </Suspense>
        ),
      },
      {
        path: "engagement-task/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EngagementTaskDetails />
          </Suspense>
        ),
      },
      {
        path: "reply-task/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ReplyTaskDetails />
          </Suspense>
        ),
      },
      {
        path: "onboarding-task-details/:type/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingTaskDetails />
          </Suspense>
        ),
      },
      {
        path: "onboarding-task-view/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingTaskView />
          </Suspense>
        ),
      },
      {
        path: "onboarding-approval",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingApproval />
          </Suspense>
        ),
      },
      {
        path: "onboarding-approval-details/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "onboarding-review-edit/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "re-onboarding-review-edit/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "campaign-approval",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignApproval />
          </Suspense>
        ),
      },
      {
        path: "campaign-approval-details/:actionId",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "ab-test-approval-details",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AbTestApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "ab-test-final-approval-details",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AbTestFinalApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "ab-test-final-approval-details/:id/:name",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AbTestFinalApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: "all-action",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ActionList />
          </Suspense>
        ),
      },
      {
        path: "my-action",
        element: (
          <Suspense fallback={<Backdrop />}>
            <MyActionList />
          </Suspense>
        ),
      },
      {
        path: "my-action/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <MyActionList />
          </Suspense>
        ),
      },
      {
        path: "details/:type/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ActionDetails />
          </Suspense>
        ),
      },
    ],
  },
];
